module.exports = __webpack_public_path__ + "static/media/r155.85ea1cf5.jpg";